import { dataHooks } from '@wix/data-hooks';

export const appDataHooks = dataHooks<{
  appContainer;
  loader;
}>('contactApp');
